<template>
  <div class="recommend">
    <mt-header title="申请的专家">
      <mt-button icon="back" slot="left" @click.native="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div>
      <div v-if="project" class="pjtTitle">
        <div class="bgimg" :class="{'zhaomu':project.status==4,'close':project.status==5,'jinxing':project.status==7,'over':project.status==8,'hezuo':project.status==6,'pingjia':project.status==9,'shenhe':project.status==1}"></div>
        <p>{{project.title}}</p>
        <span>{{project.createTime | formatDate}}</span>
      </div>
      <div class="list_wrap">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="list" v-for="(recommend, index) in recommendLists" :key="index" style='padding:0 10px 10px;background-color: #fff;border-bottom: 1px solid #ccc;'>
            <div class="jumpBtn" v-if="recommend.personalInformation[0]" @click="toPersonDetail(recommend.personalInformation[0].account)">主页></div>
            <div class="info_wrap">
              <div v-if="recommend.personalInformation[0]" class="portrait">
                <img :src="httpUrl+recommend.personalInformation[0].photo">
              </div>
              <div class="info">
                <div v-if="recommend.personalInformation[0]">
                  <div class="line_one">
                    <span>{{recommend.personalInformation[0].account.name}}</span><icon name='venus' v-if="recommend.personalInformation[0].sex == 0"></icon><icon name='mars' v-else></icon><span>{{recommend.personalInformation[0].position}}</span>
                  </div>
                  <div class="line_two">
                    <span>{{recommend.personalInformation[0].cityName}}</span><span>{{recommend.personalInformation[0].enterTypeName}}</span><span>{{recommend.personalInformation[0].experienceName}}</span><span>{{recommend.salary}}元/天</span><span>{{recommend.turnover}}单</span>
                  </div>
                </div>
                <div>
                  <div v-if="recommend.personalInformation[0]!=null && recommend.personalInformation[0].positionTypeName!=null" class="labels">
                    <span v-for='(skillsList,index) in recommend.personalInformation[0].positionTypeName.split(",")' :key="index">{{skillsList}}</span>
                  </div>
                  <div class="stars" v-if="recommend.star==5">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><span>5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==4.5">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><span>4.5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==4">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><span>4分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==3.5">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><span>3.5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==3">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>3分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==2.5">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>2.5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==2">
                    <icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>2分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==1.5">
                    <icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>1.5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==1">
                    <icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>1分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==0.5">
                    <icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>0.5分</span>
                  </div>
                  <div class="stars" v-else-if="recommend.star==0">
                    <icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>暂无评分</span>
                  </div>
                  <div class="rate">
                    <p>准时率 <span>{{recommend.punctuality}}%</span></p>
                    <p>完成质量 <span>{{recommend.quality}}%</span></p>
                    <p>满意度 <span>{{recommend.satisfaction}}%</span></p>
                  </div>
                  <div v-if="recommend.personalInformation[0]!=null && recommend.personalInformation[0].skills!=null" class="skill">
                    <span v-for='(skillsList,index) in recommend.personalInformation[0].skills.split("@")' :key="index">{{skillsList}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="introduce">
              <p><span @click="litter" :class="{'select':introduce==true}">申请信</span><span @click="itd" :class="{'select':introduce==false}">个人简介</span></p>
              <pre v-if="introduce">{{recommend.content}}</pre>
              <pre v-else><span v-if="recommend.personalInformation[0]">{{recommend.personalInformation[0].aboutMe}}</span></pre>
            </div>
            <div  class="btns">
              <button type="button" @click="toHireDetail(recommend.personalInformation[0].account)">雇佣专家</button>
              <button v-if="false" type="button">发送消息</button>            
            </div>
          </div>
        </van-list>
        </mt-loadmore>
      </div>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'message',
  data () {
    return {
      introduce: true,
      status: 4,
      gender: true,
      star: 4,
      projectId: this.$route.query.projectId,
      recommendLists: '',
      searchCondition: {
        pageNo: 0,
        pageSize: '10'
      },
      allLoaded: false,
      scrollMode: 'auto',
      project: '',
      httpUrl: '',
      flag:'',
      loading: false,
      finished: false,
    }
  },
  mounted () {
    this.STATE.state.myProjectDetailId = this.$route.query.projectId
    this.loadPageList()
  },
  methods: {
    onLoad: function () {
      let _this = this
      this.searchCondition.pageNo = this.searchCondition.pageNo + 1
      setTimeout(() => {
        this.axios.get('url/projectApplyers?accountId=' + _this.STATE.state.loginId+ '&projectId=' + _this.projectId  + '&rows=10&page=' + _this.searchCondition.pageNo)
        .then(function (res) {
          if(res){
            // 加载状态结束
            _this.loading = false;
            if(_this.searchCondition.pageNo==1){
              _this.recommendLists = res.data.applyExpert
            }else{
              _this.recommendLists = _this.recommendLists.concat(res.data.applyExpert)
            }
            if (res.data.applyExpert.length <10) {
                _this.finished = true;
            }
          }
        }).catch(function (response) {
        })
      }, 500)
    },
    litter: function () {
      this.introduce = true
    },
    itd: function () {
      this.introduce = false
    },
    loadTop: function () {
      this.loadPageList()
      this.$refs.loadmore.onTopLoaded()
    },
    loadBottom: function () {
      this.more()
      this.$refs.loadmore.onBottomLoaded()
    },
    loadPageList: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/projectApplyers?accountId=' + this.STATE.state.loginId + '&projectId=' + this.projectId + '&rows=10&page=1')
      .then(function (res) {
        Indicator.close()
        _this.recommendLists = res.data.applyExpert
        _this.project = _this.recommendLists[0]
        _this.httpUrl = res.data.httpUrl
        if (res.data.applyExpert.length < 10) {
          _this.finished = true
        }else{
          _this.finished = false;
        }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios.get('url/projectApplyers?accountId=' + this.STATE.state.loginId + '&projectId=' + this.projectId + '&rows=10&page=' + this.searchCondition.pageNo)
      .then(function (res) {
        Indicator.close()
        _this.recommendLists = _this.recommendLists.concat(res.data.applyExpert)
        _this.project = _this.recommendLists[0]
        _this.httpUrl = res.data.httpUrl
        if (res.data.length !== 10) {
          _this.allLoaded = true
        }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    toPersonDetail (account) {
      this.$router.push({path: '/myDetail', query: { id: account.id }})
    },
    toHireDetail: function (account) {
      if (account.status === 4) {
        this.$router.push({path: '/project/hireExpert', query: { id: account.id, projectId: this.projectId, projectTitle: this.project.title }})
      } else {
        Toast({
          message: '该专家不具备接项目的资质',
          position: 'middle',
          duration: 1000
        })
      }
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
.recommend{
  background-color: #f0eff5;
}
.pjtTitle{
  padding: 12px 19px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 6px;
  background-color: #fff;
}
.pjtTitle p{
  font-size: 15px;
  color: #727272;
  white-space: nowrap;  
  overflow: hidden;
  text-overflow: ellipsis;
}
.pjtTitle span{
  font-size: 12px;
  color: #727272;
}
.pjtTitle span:nth-child(4){
  margin-left: 10px;
}
.pjtTitle .bgimg{
    width:44px;
    height:44px;
    float:right;
    margin-right:-19px;
    margin-top:-12px;
    background-size:100% 100%;
  }
  .pjtTitle .zhaomu{
    background-image:url('../assets/img/main_app/state-4.png');
  }
  .pjtTitle .close{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .pjtTitle .jinxing{
    background-image:url('../assets/img/main_app/state-7.png');
  }
  .pjtTitle .over{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .pjtTitle .hezuo{
    background-image:url('../assets/img/main_app/state-6.png');
  }
  .pjtTitle .pingjia{
    background-image:url('../assets/img/main_app/state-9.png');
  }
  .list{
    padding:0 10px 10px;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
  }
  .list .jumpBtn{
    padding:10px 0;
    text-align: right;
    color: #108ee9;
    font-size: 12px;
  }
  .list .info_wrap{
    display: table;
  }
  .list .portrait{
    display: table-cell;
    width: 60px;
    height: 70px;
  }
  .list .portrait img{
    width: 50px;
    height: 50px;
    border-radius:50%;
    -webkit-border-radius:50%;
    -moz-border-radius:50%;
  }
  .list .info{
    display: table-cell;
    vertical-align: top;
  }
  .list .info .line_one span{
    color:#108ee9;
    font-size: 12px;
  }
  .list .info .line_one span:nth-child(1){
    font-size: 14px;
  }
   .list .info .line_one .fa-icon{
    color:#108ee9;
    transform: scale(0.9);
    vertical-align: middle;
    margin: 0 10px 0 4px;
  }
  .list .info .line_two span{
    font-size: 12px;
    color: #727272;
    margin-right:10px;
    display: inline-block;
  }
  .info .labels span{
    border: 1px solid #108ee9;
    color: #108ee9;
    font-size: 12px;
    padding: 1px 5px;
    border-radius:3px;
    -webkit-border-radius:3px;
    -moz-border-radius:3px;
    margin: 5px;
    display: inline-block;
  }
  .stars .fa-icon{
    transform: scale(.9);
    color:#fd9100;
    margin: 2px;
  }
  .stars span{
    font-size: 14px;
    vertical-align: top;
    margin-left: 10px;
    color: #727272;
  }
  .info .rate{
    overflow: hidden;
  }
  .info .rate p{
    float: left;
    font-size: 12px;
    color: #727272;
    margin-right: 10px;
  }
  .info .rate p span{
    font-size: 15px;
    color: #000;
  }
  .skill span{
    background-color:#f2f2f2;
    color: #989898;
    font-size: 12px;
    padding: 1px 5px;
    border-radius:3px;
    -webkit-border-radius:3px;
    -moz-border-radius:3px;
    margin: 5px;
    display: inline-block;
  }
  .introduce{
    margin-top: 10px;
  }
   .introduce p{
     text-align: center;
     font-size: 14px;
   }
   .introduce p span{
     padding: 2px 10px;
   }
   .introduce .select{
     color: #108ee9;
     border-bottom: 1px solid #108ee9;
   }
  .introduce pre{
    font-size: 12px;
    color: #7e7e7e;
    padding: 5px 10px;
    margin-top: 10px;
  }
  .btns{
    text-align: center;
    margin-top:5px;
  }
  .btns button{
    width: 40%;
    height: 30px;
    border: none;
    outline: none;
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
    margin: 0 5px;
    color: #fff;
  }
  .btns button:nth-child(1){
    background-color: #0678cb;
  }
  .btns button:nth-child(2){
    background-color: #108ee9;
  }
  .list_wrap{
    margin-bottom:70px;
  }
</style>


// WEBPACK FOOTER //
// applyPeople.vue?80dcece0